import React, { useEffect, useState } from "react";
import "./paymentNusxa.scss";
import { ReactComponent as ScrollA } from "../../../icons/scroll-a.svg";
import PayedPriceDetails from "../PayedPriceDetails/PayedPriceDetails";

const PayedOrders = ({ main, sub, selectedOrders, all }) => {
  return (
    <div className={`payed-orders ${selectedOrders.length > 2 && "lg"}`}>
      <div className="txts">
        <div className="main">{main}</div>
      </div>

      <div className="items-c">
        <div className="items">
          {selectedOrders?.map((order, i) => (
            <PayedPriceDetails order={order} key={i} all={all} />
          ))}
        </div>
        {selectedOrders.length > 2 && <ScrollA className="icon" />}
      </div>
    </div>
  );
};

export default PayedOrders;
